<template>
  <div class="page-device">
    <button class="page-device-button" data-pdui-tooltip="hover"
            data-pdui-tooltip-title="上一页"
            @click="jumpList('up')"
            :class="{'disabled':value && value.page === 1}"
            :disabled="value && value.page === 1">
      <svg height="24" width="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"></path>
      </svg>
    </button>
    <div class="page-size-container">
      <div class="page-text">
        <span>每页</span>
        <span class="pdvis-page-pagesize page-device-size" @click="openChoose"
              :title="activeNum">{{activeNum}}</span>
        <ul
          class="pdui-select-dropdown pdui-select-dropdown-fixed pdui-select-dropdown-arrow pdui-select-xs active page-device-ul"
          v-if="isChoose">
          <li class="" v-for="(item, index) in numArr" :key="index"
              :title="item"
              :class="{'active': item === activeNum}"
              @click="change(item)">{{item}}
          </li>
          <li class="pdui-divider" title=""></li>
          <li class="pdvis-page-pagesize-custom" title="自定义" @click="customNum">
            <svg height="20" width="20" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"></path>
            </svg>
            自定义
          </li>
        </ul>
      </div>
    </div>
    <button class="page-device-button" data-pdui-tooltip="hover"
            data-pdui-tooltip-title="下一页"
            @click="jumpList('next')"
            :class="{'disabled': value && value.page === value.pageCount}"
            :disabled="value && value.page === value.pageCount">
      <svg height="24" width="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"></path>
      </svg>
    </button>
    <el-dialog
      title="自定义每页数量"
      :modal="false"
      :visible.sync="dialogVisible"
      width="350px">
      <el-form
        label-width="80px"
        label-position="left">
        <el-form-item label="数量"
                      required>
          <el-input v-model.number="customNumber" size="small"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false" size="small">取 消</el-button>
    <el-button type="primary" @click="change(customNumber)" size="small">确 定</el-button>
  </span>
    </el-dialog>
  </div>
</template>

<script>
import * as _ from 'lodash'

export default {
  name: 'pageDevice',
  props: {
    value: {
      type: Object
    }
  },
  data () {
    return {
      numArr: [10, 20, 50, 100],
      activeNum: 20,
      customNumber: 0,
      isChoose: false,
      dialogVisible: false
    }
  },
  methods: {
    change (val) {
      this.activeNum = val
      this.$emit('change', this.activeNum)
      this.isChoose = false
      this.dialogVisible = false
    },
    openChoose () {
      this.isChoose = !this.isChoose
      if (this.isChoose) {
        window.addEventListener('click', (e) => {
          if (!(e.target && e.target.className === 'pdvis-page-pagesize page-device-size')) {
            this.isChoose = false
          }
          e.stopPropagation()
        })
      }
    },
    customNum () {
      this.isChoose = false
      this.customNumber = _.cloneDeep(this.activeNum)
      this.dialogVisible = true
    },
    jumpList (val) {
      if (val === 'up') {
        this.value.page = this.value.page - 1
      } else {
        this.value.page = this.value.page + 1
      }
      this.$emit('jump', this.value.page)
    }
  }
}
</script>

<style scoped lang="scss">
  /deep/ .el-dialog__header {
    height: 48px;
    border-bottom: 1px solid #ddd;
    line-height: 48px;
    padding: 0 24px;
    font-weight: bolder;
    font-size: 16px;

    .el-dialog__headerbtn {
      top: 14px
    }
  }

  .page-device {
    display: flex;
    background: #ffffff;
    border: 1px solid rgba(0, 0, 0, 0.1);
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;

    button svg {
      fill: rgba(0, 0, 0, .2);
    }

    .disabled {
      cursor: not-allowed;

      &:hover {
        background-color: #f6f6f6;
      }
    }

    .page-device-button {
      width: 26px;
      height: 30px;
      display: flex;
      align-items: center;
      box-sizing: border-box;
      background: #fff;
      box-shadow: 0 1px 1px 0 rgba(0, 0, 0, .1);
      outline: none !important;
      border: none;
      justify-content: center;
    }

    .page-device-button:first-child {
      border-radius: 2px 0 0 2px;
    }

    .page-device-button:last-child {
      border-radius: 0 2px 2px 0;
    }

    .page-device-ul {
      position: absolute;
      top: 32px;
      left: 0;

      .active {
        color: #00b38a;
      }
    }

    .page-text {
      display: flex;
      align-items: center;
      height: 30px;
      padding: 4px;
      box-sizing: border-box;
      width: 88px;
      position: relative;
      color: rgba(0, 0, 0, .4);
      border-left: 1px solid #ddd;
      border-right: 1px solid #ddd;
    }

    .page-device-size {
      display: block;
      width: 48px;
      color: rgba(0, 0, 0, .8);
      cursor: pointer;
      border-radius: 2px 2px 2px 2px;
      background: #ffffff no-repeat 100%;
      background-image: url(data:image/svg+xml;charset=UTF-8,%3Csvg%20fill%3D%22rgba%280,%200,%200,%200.8%29%22%20height%3D%2216%22%20viewBox%3D%220%200%2024%2024%22%20width%3D%2216%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%3E%3Cpath%20d%3D%22M7%2010l5%205%205-5z%22%3E%3C/path%3E%3C/svg%3E);
      padding: 0 16px 0 8px;
      transition: all .5s cubic-bezier(.25, .8, .25, 1) 0s;
      word-break: keep-all;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
</style>
